// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__27bRM","primary":"Button_primary__3UBur","secondary":"Button_secondary__1o7ka"};